export default {
    name: 'caseInfo',
    data () {
        return {
            caseInfo:'',
            downInfo:{
                downUrl: this.$baseURL+'/file/download',
                filePath:'',
                fileName:'',
            }
            
        }
    },
     methods: {
        getCaseInfo(){
            this.$request.post('/industryCase/getIndustryCaseById',{
                id:this.$route.query.id,
            }).then((res)=>{
                if(res.code ==0) {
                    this.caseInfo = res.obj
                }else{
                    this.$vux.toast.show({
                        type: 'warn',
                        text: res.msg
                    })
                }
            })
        },
        downloadFile(filePath,fileName){
            this.downInfo.filePath = filePath
            this.downInfo.fileName = fileName
            this.$nextTick(function(){
                this.$refs.downFrom.submit()
            })
        }
     },
     computed: {
    
    },
     created() {
         this.getCaseInfo()
     },
     mounted() {
    
    },
}


// WEBPACK FOOTER //
// ./src/views/caseInfo/script.js